import DtoPiezometryStationMeasure from '../../../station/dto/piezometer/DtoPiezometryStationMeasure'

export default class DtoInstallationMeasures {
    constructor(obj) {
        this.piezometerId = obj.piezometerId
        this.measures = obj.measures.map(m => new DtoPiezometryStationMeasure(m))
    }
}